import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/config/site";
import { localeUrl } from "@/lib/seo";
import { ForgotPasswordPage } from "@/components/auth/forgot-password-page";
import { headMessage } from "@/lib/i18n";

export const Route = createFileRoute("/$locale/auth/forgot-password")({
  head: ({ params, matches }) => {
    const canonicalUrl = localeUrl(params.locale, "/auth/forgot-password");
    return {
      meta: [
        { title: pageTitle(headMessage(matches, "auth.forgot.metaTitle")) },
        {
          name: "description",
          content: headMessage(matches, "auth.forgot.metaDescription"),
        },
        { name: "robots", content: "noindex,follow" },
        { property: "og:url", content: canonicalUrl },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: ForgotPasswordPage,
});
